window.MKDP = window.MKDP || {};
MKDP.state = { config: null, origBytes: null, fetching: null, pdfjs: null, doc: null, docName: '', page: 1, cache: {}, renderToken: 0 };
MKDP.els = {};
MKDP.CSS = '\
.mkd-slot{margin:14px 0 4px}\
.mkd-open{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:54px;padding:14px 20px;border:2px solid #2E1A38;border-radius:999px;background:#fff;color:#2E1A38;font:inherit;font-weight:700;font-size:17px;cursor:pointer;-webkit-tap-highlight-color:transparent}\
.mkd-open:active{transform:scale(.99)}\
.mkd-open-sub{margin:6px 0 0;text-align:center;font-size:13.5px;color:#6E5A7E}\
.mkd-overlay{position:fixed;inset:0;z-index:9999;background:#FFFBF3;color:#2E1A38;display:flex;flex-direction:column;height:100dvh;padding:env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);overscroll-behavior:contain;animation:mkdIn .18s ease-out}\
@keyframes mkdIn{from{opacity:0}to{opacity:1}}\
.mkd-overlay[hidden]{display:none}\
.mkd-topbar{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:12px 14px 2px}\
.mkd-title{font-family:Fraunces,Georgia,serif;font-weight:600;font-size:15.5px;line-height:1.3;color:#2E1A38;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}\
.mkd-close{flex:0 0 auto;width:38px;height:38px;border-radius:50%;border:1px solid #E9DEF2;background:#fff;color:#2E1A38;font-size:16px;line-height:1;cursor:pointer;box-shadow:0 2px 8px rgba(46,26,56,.08)}\
.mkd-namebar{display:flex;align-items:center;gap:10px;padding:8px 14px 4px;flex-wrap:wrap}\
.mkd-namecard{display:flex;flex-direction:column;gap:1px;flex:1 1 auto;background:#fff;border:1px solid #E9DEF2;border-radius:16px;padding:8px 14px 9px;box-shadow:0 2px 10px rgba(46,26,56,.06);cursor:text}\
.mkd-namelabel{font-size:10.5px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#9A86AD}\
.mkd-name-input{border:none;outline:none;padding:0;min-height:26px;background:transparent;font:inherit;font-size:16.5px;font-weight:600;color:#2E1A38;width:100%}\
.mkd-name-input::placeholder{color:#BCAED0;font-weight:400}\
.mkd-note{flex:1 1 100%;font-size:13px;color:#7A4491}\
.mkd-stage{position:relative;flex:1 1 auto;display:flex;align-items:center;justify-content:center;overflow:hidden;touch-action:none;padding:2px 4px;background:radial-gradient(120% 90% at 50% 38%,#fdfaff 0%,#FFFBF3 58%,#F3EAF8 100%)}\
.mkd-canvas-wrap{position:relative;display:flex;align-items:center;justify-content:center;max-width:100%;max-height:100%}\
.mkd-canvas{max-width:100%;max-height:100%;border-radius:6px;box-shadow:0 16px 40px rgba(46,26,56,.26);background:#fff;transform-origin:center center}\
.mkd-nav{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:48px;height:48px;border-radius:50%;border:none;background:rgba(46,26,56,.82);color:#fff;font-size:26px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;box-shadow:0 6px 18px rgba(46,26,56,.35)}\
.mkd-prev{left:8px}.mkd-next{right:8px}\
.mkd-nav[disabled]{opacity:.28}\
.mkd-loading{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;background:rgba(255,251,243,.94);z-index:4;text-align:center;padding:20px}\
.mkd-loading[hidden]{display:none}\
.mkd-bar{width:min(300px,80vw);height:8px;border-radius:99px;background:#E9DEF2;overflow:hidden}\
.mkd-bar span{display:block;height:100%;width:0;background:#5B2A6E;border-radius:99px;transition:width .2s}\n.mkd-skelpage{width:calc((100vw - 24px) * 0.5);height:calc((100vw - 24px) * 0.6614);max-width:92%;max-height:88%;aspect-ratio:3 / 4;border-radius:6px;border:1px solid #E2CFF0;background-color:#EFE7F7;background-image:linear-gradient(100deg,#EFE7F7 40%,#FBF8FE 50%,#EFE7F7 60%);background-size:200% 100%;box-shadow:0 12px 32px rgba(46,26,56,.12);animation:mkdShimmer 1.25s linear infinite}@keyframes mkdShimmer{from{background-position:120% 0}to{background-position:-80% 0}}@media (prefers-reduced-motion: reduce){.mkd-skelpage{animation:none}}\
.mkd-loading p{margin:0;font-size:15px;font-weight:600}\
.mkd-bottombar{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:6px 14px 0}\
.mkd-counter{font-weight:700;font-size:14.5px;white-space:nowrap}\
.mkd-hint{font-size:12px;color:#6E5A7E;white-space:nowrap}\
.mkd-smallprint{margin:0;padding:2px 14px 10px;font-size:11.5px;line-height:1.45;color:#6E5A7E;text-align:center}\
.mkd-status{margin:0;padding:6px 16px 10px;font-size:13px;color:#b3261e;text-align:center;font-weight:600}\
.mkd-buybar{display:flex;gap:10px;padding:8px 12px 2px;align-items:stretch}\
.mkd-buybar[hidden]{display:none}\
.mkd-formats{display:flex;gap:8px;flex:1 1 auto}\
.mkd-format{flex:1 1 0;border:2px solid #D8CCE4;border-radius:16px;background:#fff;padding:7px 4px 6px;text-align:center;cursor:pointer;font:inherit;color:#2E1A38;-webkit-tap-highlight-color:transparent}\
.mkd-format[aria-checked="true"]{border-color:#2E1A38;background:#2E1A38;color:#fff}\
.mkd-format-label{display:block;font-size:12.5px;font-weight:600}\
.mkd-format-price{display:block;font-weight:700;font-size:16px;line-height:1.25}\
.mkd-format-tag{display:block;font-size:10.5px;font-weight:700;letter-spacing:.03em;color:#7A4491;text-transform:uppercase}\
.mkd-format[aria-checked="true"] .mkd-format-tag{color:#D9B8E8}\
.mkd-atc{flex:0 0 auto;min-width:136px;min-height:52px;border:none;border-radius:999px;background:#5B2A6E;color:#fff;font:inherit;font-weight:700;font-size:16px;padding:10px 18px;cursor:pointer;-webkit-tap-highlight-color:transparent}\
.mkd-atc[disabled]{opacity:.55}\
.mkd-buyhint{margin:0;padding:3px 14px 0;font-size:13px;color:#7A4491;text-align:center;font-weight:600}\
.mkd-buyhint[hidden]{display:none}\
.mkd-shake{animation:mkdShake .3s ease-in-out}\
@keyframes mkdShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-5px)}75%{transform:translateX(5px)}}\
.mkd-open-primary{background:#5B2A6E;color:#fff}\
.mkd-stickybar{position:fixed;left:0;right:0;bottom:0;z-index:900;display:none;align-items:center;gap:12px;padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:#FFFBF3;border-top:1px solid #E9DEF2;box-shadow:0 -6px 20px rgba(46,26,56,.12)}\
.mkd-sticky-info{display:flex;flex-direction:column;line-height:1.25}\
.mkd-sticky-price{font-weight:700;font-size:16px;color:#2E1A38}\
.mkd-sticky-sub{font-size:12px;color:#6E5A7E}\
.mkd-sticky-btn{flex:1 1 auto;min-height:50px;border:none;border-radius:999px;background:#5B2A6E;color:#fff;font:inherit;font-weight:700;font-size:16px;cursor:pointer}\
@media (max-width:749px){.mkd-stickybar[data-on="1"]{display:flex}}\
@media (max-width:560px){.mkd-buybar{flex-wrap:wrap}.mkd-atc{flex:1 1 100%}}\
.mkd-canvas-wrap{perspective:1600px}\
.mkd-canvas.mkd-right{margin-left:0}\
.mkd-canvas.mkd-left{border-radius:6px 0 0 6px}\
.mkd-canvas.mkd-right{border-radius:0 6px 6px 0}\
.mkd-spine{position:absolute;left:50%;width:34px;transform:translateX(-50%);background:linear-gradient(90deg,rgba(46,26,56,0),rgba(46,26,56,.05) 32%,rgba(46,26,56,.24) 50%,rgba(46,26,56,.05) 68%,rgba(46,26,56,0));pointer-events:none;z-index:2}\
.mkd-spacer{flex:0 0 auto}\
.mkd-leaf{position:absolute;z-index:5;transform-style:preserve-3d;pointer-events:none}\
.mkd-flipshadow{position:absolute;z-index:4;pointer-events:none;border-radius:6px;opacity:0}\
.mkd-leaf-face{position:absolute;inset:0;width:100%;height:100%;backface-visibility:hidden;-webkit-backface-visibility:hidden;border-radius:6px;background:#fff;box-shadow:0 10px 34px rgba(46,26,56,.22)}\
.mkd-leaf-back{transform:rotateY(180deg)}\
@media (min-width:750px){.mkd-open{width:auto;min-width:340px}.mkd-slot{text-align:left}.mkd-open-sub{text-align:left}.mkd-title{font-size:20px}.mkd-nav{width:54px;height:54px;font-size:30px}}\
';
MKDP.injectCss = function () {
  if (document.getElementById('mkd-preview-css')) return;
  var st = document.createElement('style');
  st.id = 'mkd-preview-css';
  st.textContent = MKDP.CSS;
  document.head.appendChild(st);
};
MKDP.buildOverlay = function () {
  var els = MKDP.els, state = MKDP.state;
  var ov = document.createElement('div');
  ov.className = 'mkd-overlay';
  ov.hidden = true;
  ov.setAttribute('role', 'dialog');
  ov.setAttribute('aria-label', 'Book preview');
  ov.innerHTML =
    '<div class="mkd-topbar"><div class="mkd-title"></div>' +
    '<button class="mkd-close" type="button" aria-label="Close preview">\u2715</button></div>' +
    '<div class="mkd-namebar"><label class="mkd-namecard"><span class="mkd-namelabel">Child\u2019s first name</span>' +
    '<input class="mkd-name-input" type="text" maxlength="12" autocomplete="off" placeholder="e.g. Sofia"></label>' +
    '<div class="mkd-note" hidden>We can show this name inside the story, but not in the cover title yet.</div></div>' +
    '<div class="mkd-stage">' +
    '<button class="mkd-nav mkd-prev" type="button" aria-label="Previous page">\u2039</button>' +
    '<div class="mkd-canvas-wrap"><div class="mkd-spacer" hidden></div><canvas class="mkd-canvas mkd-left"></canvas><div class="mkd-spine" hidden></div><canvas class="mkd-canvas mkd-right" hidden></canvas>' +
    '<div class="mkd-flipshadow" hidden></div>' +
    '<div class="mkd-leaf" hidden><canvas class="mkd-leaf-face mkd-leaf-front"></canvas><canvas class="mkd-leaf-face mkd-leaf-back"></canvas></div>' +
    '</div>' +
    '<button class="mkd-nav mkd-next" type="button" aria-label="Next page">\u203a</button><div class="mkd-loading"><div class="mkd-skelpage" aria-hidden="true"></div><div class="mkd-bar"><span></span></div><p>Preparing the real book\u2026</p></div></div>' +
    '<div class="mkd-bottombar"><span class="mkd-counter"></span><span class="mkd-hint">Swipe or tap the arrows \u00b7 pinch to zoom</span></div>' +
    '<div class="mkd-buybar" hidden><div class="mkd-formats" role="radiogroup" aria-label="Choose a format"></div>' +
    '<button class="mkd-atc" type="button">Add to Cart</button></div>' +
    '<p class="mkd-buyhint" hidden></p>' +
    '<p class="mkd-smallprint">The real book, with your child\u2019s name in it, printed from this same file. Colors may vary slightly in print.</p>' +
    '<p class="mkd-status" hidden></p>';
  document.body.appendChild(ov);
  els.overlay = ov;
  els.title = ov.querySelector('.mkd-title');
  els.input = ov.querySelector('.mkd-name-input');
  els.note = ov.querySelector('.mkd-note');
  els.stage = ov.querySelector('.mkd-stage');
  els.wrap = ov.querySelector('.mkd-canvas-wrap');
  els.canvasL = ov.querySelector('.mkd-left');
  els.canvasR = ov.querySelector('.mkd-right');
  els.spine = ov.querySelector('.mkd-spine');
  els.spacer = ov.querySelector('.mkd-spacer');
  els.leaf = ov.querySelector('.mkd-leaf');
  els.flipshadow = ov.querySelector('.mkd-flipshadow');
  els.leafFront = ov.querySelector('.mkd-leaf-front');
  els.leafBack = ov.querySelector('.mkd-leaf-back');
  els.loading = ov.querySelector('.mkd-loading');
  els.barFill = ov.querySelector('.mkd-bar span');
  els.loadText = ov.querySelector('.mkd-loading p');
  els.counter = ov.querySelector('.mkd-counter');
  els.status = ov.querySelector('.mkd-status');
  els.buybar = ov.querySelector('.mkd-buybar');
  els.formats = ov.querySelector('.mkd-formats');
  els.atc = ov.querySelector('.mkd-atc');
  els.buyhint = ov.querySelector('.mkd-buyhint');
  els.prev = ov.querySelector('.mkd-prev');
  els.next = ov.querySelector('.mkd-next');
  ov.querySelector('.mkd-close').addEventListener('click', MKDP.closeOverlay);
  els.prev.addEventListener('click', function () { MKDP.step(-1); });
  els.next.addEventListener('click', function () { MKDP.step(1); });
  var deb;
  els.input.addEventListener('input', function () {
    clearTimeout(deb);
    deb = setTimeout(function () { MKDP.applyName(els.input.value, true); }, 650);
  });
  document.addEventListener('keydown', function (e) {
    if (ov.hidden) return;
    if (e.key === 'Escape') MKDP.closeOverlay();
    if (e.key === 'ArrowLeft') MKDP.step(-1);
    if (e.key === 'ArrowRight') MKDP.step(1);
  });
  MKDP.bindGestures();
  var rto;
  window.addEventListener('resize', function () {
    if (ov.hidden) return;
    clearTimeout(rto);
    rto = setTimeout(function () { MKDP.resetZoom(); if (MKDP.clearBitmaps) MKDP.clearBitmaps(); MKDP.renderView(); }, 200);
  });
};
MKDP.zoom = 1; MKDP.panX = 0; MKDP.panY = 0;
MKDP.applyTransform = function () {
  MKDP.els.wrap.style.transform = 'translate(' + MKDP.panX + 'px,' + MKDP.panY + 'px) scale(' + MKDP.zoom + ')';
};
MKDP.resetZoom = function () { MKDP.zoom = 1; MKDP.panX = 0; MKDP.panY = 0; MKDP.applyTransform(); };
MKDP.bindGestures = function () {
  var stage = MKDP.els.stage;
  var pointers = {}, pinchDist = 0, lastTap = 0, startX = 0, startY = 0, moved = false;
  stage.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('button')) return; // let nav buttons receive their click
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (Object.keys(pointers).length === 1) { startX = e.clientX; startY = e.clientY; moved = false; }
    if (Object.keys(pointers).length === 2) {
      var p = Object.values(pointers);
      pinchDist = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
    }
    try { stage.setPointerCapture(e.pointerId); } catch (err) {}
  });
  stage.addEventListener('pointermove', function (e) {
    if (!pointers[e.pointerId]) return;
    var prev = pointers[e.pointerId];
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (ids.length === 2) {
      var p = Object.values(pointers);
      var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      if (pinchDist > 0) {
        MKDP.zoom = Math.min(3.2, Math.max(1, MKDP.zoom * (d / pinchDist)));
        if (MKDP.zoom === 1) { MKDP.panX = 0; MKDP.panY = 0; }
        MKDP.applyTransform();
      }
      pinchDist = d; moved = true;
    } else if (ids.length === 1) {
      var dx = e.clientX - prev.x, dy = e.clientY - prev.y;
      if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) moved = true;
      if (MKDP.zoom > 1) { MKDP.panX += dx; MKDP.panY += dy; MKDP.applyTransform(); }
    }
  });
  function endPointer(e) {
    if (!(e.pointerId in pointers)) return; // release of a tap that started on a button: not a gesture
    var wasPinch = Object.keys(pointers).length === 2;
    delete pointers[e.pointerId];
    if (wasPinch) pinchDist = 0;
    if (Object.keys(pointers).length > 0) return;
    var dx = e.clientX - startX, dy = e.clientY - startY;
    var now = Date.now();
    if (!moved || (Math.abs(dx) < 10 && Math.abs(dy) < 10)) {
      if (now - lastTap < 320) {
        MKDP.zoom = MKDP.zoom > 1 ? 1 : 2.1;
        if (MKDP.zoom === 1) { MKDP.panX = 0; MKDP.panY = 0; }
        MKDP.applyTransform();
      }
      lastTap = now;
      return;
    }
    if (MKDP.zoom === 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      MKDP.step(dx < 0 ? 1 : -1);
    }
  }
  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', function (e) { delete pointers[e.pointerId]; });
};
MKDP.setLoading = function (show, frac, text) {
  var els = MKDP.els;
  els.loading.hidden = !show;
  if (typeof frac === 'number') els.barFill.style.width = Math.round(frac * 100) + '%';
  if (text) els.loadText.textContent = text;
};
MKDP.closeOverlay = function () {
  MKDP.els.overlay.hidden = true;
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
};
